import { ArrowRight } from "lucide-react";
import { newPlan, type TodayPlan } from "@/content/pricing/plans";
import { fill, type PricingCopy } from "@/content/pricing";

/**
 * How one of today's plans becomes a new one, everywhere on /pricing-changes-2026:
 * - a rename reads as a name change, "Enterprise (now called Max)": same plan, new name;
 * - every other plan shows "From → To" (Pay as you go → Lite moves to the $0 plan; Lite → Lite and
 *   Pro → Pro keep their names on the new terms).
 */
const PlanMove = ({ from, copy, arrowSize = 14 }: { from: TodayPlan; copy: PricingCopy; arrowSize?: number }) => {
  const to = newPlan(from.movesTo);
  if (from.renamed) return <>{fill(copy.common.renamedPlan, { from: from.name, to: to.name })}</>;
  return (
    <>
      {from.name} <ArrowRight size={arrowSize} className="inline flex-shrink-0 text-hawk-orange" aria-label="→" /> {to.name}
    </>
  );
};

export default PlanMove;
